import './listing-details.css';

import React, { useCallback, useMemo, useState } from 'react';
import { MediaGallery } from './media-gallery';
import { MediaGalleryFullScreen } from './media-gallery-full-screen';
import { ListingHighlights } from './listing-highlights';
import { ContactRequest } from './contact-request';
import { ListingPrice } from './listing-price';
import { IListing } from '../../models/listing.model';
import ListingInformation from './listing-information';
import { IBranding } from '../../models/branding.model';
import { ContactAgentPhone } from './contact-agent-phone';
import { formatListingType } from '../../util/format-listing-strings';
import { formatListingCommunityName } from '../../util/format-listing-strings';

export interface IListingDetails {
  branding: IBranding;
  listing: IListing;
}

export const ListingDetails: React.FC<IListingDetails> = (props: IListingDetails) => {
  const [openGallery, setOpenGallery] = useState(false);
  const [openGalleryInitialSlide, setOpenGalleryInitialSlide] = useState(0);
  const listingTypeText = useMemo(() => formatListingType(props.listing), [props.listing]);
  const communityName = useMemo(() => formatListingCommunityName(props.listing), [props.listing]);

  const doOpenGallery = useCallback(function (slide: number) {
    setOpenGalleryInitialSlide(slide);
    setOpenGallery(true);
  }, []);

  return (
    <div className="listing-details">
      <div className="listing-details-left">
        <MediaGallery openGallery={doOpenGallery}
          photos={props.listing.listingPhotos} />
      </div>
      <div className="listing-details-right">
        <div className="listing-details-right-header">
          <h1 className="listing-address">{props.listing.address}</h1>
          <div className="community-name">{communityName}</div>
          <div className="listing-type">{listingTypeText}</div>
          <ListingPrice price={props.listing.price} saleOrLease={props.listing.saleOrLease} />
          <ListingHighlights listing={props.listing} />
          <ContactAgentPhone branding={props.branding} showIcon />
          <ContactRequest address={props.listing.address} mlsId={props.listing.mlsId} branding={props.branding} />
        </div>
        <div className="listing-details-right-info">
          <ListingInformation branding={props.branding} listing={props.listing} />
        </div>
      </div>
      {openGallery &&
        <MediaGalleryFullScreen initialSlide={openGalleryInitialSlide} photos={props.listing.listingPhotos}
          close={() => setOpenGallery(false)} />
      }
    </div>
  );
}

export default ListingDetails;
